import useGlobalLocation from '@watershed/ui-core/hooks/useGlobalLocation';

export default function useLocationHash() {
  const { location } = useGlobalLocation();
  // Strangely, the hash shows up in either `location.hash` or
  // `location.pathname` depending of if it's the first page load or subsequent
  return location.hash.slice(1) || location.pathname.split('#')[1] || '';
}
